<h1 class="text-title-4 mb-24">{{ 'passkey.register.header' | translate }}</h1>

<div class="mb-24">
<span class="rds-pictogram-face-id"></span>
<span class="rds-pictogram-fingerprint passkey-icon-gallery"></span>
<span class="rds-pictogram-pin passkey-icon-gallery"></span>
</div>

<div class="mb-24">
  <p class="mb-8"><b>{{ 'passkey.register.description' | translate }}</b></p>
  <p class="mb-24 text-body-sm">{{ 'passkey.register.subDescription' | translate }}</p>
  <p class="mb-8"><b>{{ 'passkey.register.subHeader' | translate }}</b></p>
  <p class="mb-24 text-body-sm">{{ 'passkey.register.subHeaderDesc' | translate }}</p>
</div>

<button ds-button
        type="submit"
        role="button"
        class="w-100 mb-16"
        (click)="onCreatePasskeyClick()"
        title="Create a passKey">
     <span class="rds-icon-passkey"></span> 
        <span style="margin-left: 6px;">{{ 'passkey.register.create' | translate }}</span>
</button>

<button ds-button
       variant="secondary"
        type="submit"
        role="button"
        class="w-100 mb-16"
        (click)="onSkipPasskeyClick()"
        title="Remind me next time">
        <span>{{ 'passkey.register.remind' | translate }}</span>
</button>
<div class="ds-border-bottom mb-24 mt-16 ds-brcolor-concrete"></div>

<div class="mb-16" style="display: flow">
  <div class="mb-8"><a
    variant="cta"
    class="ds-color-link"
    (click)="onPasskeyDeclineClick()"
    attr.title="Decline">{{ 'passkey.register.ask' | translate }}
  </a></div>
  <div class="text-body-sm">
    {{ createPasskey | translate }}
  </div>
</div>